import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";

const columns = (languageData) => [
  {
    name: languageData.body.header.notifications.table.type,
    selector: (row) => row.type,
    sortable: true,
  },
  {
    name: languageData.body.header.notifications.table.title,
    selector: (row) => row.title,
    sortable: true,
  },

  {
    name: languageData.body.header.notifications.table.status,
    selector: (row) => row.status,
    sortable: true,
    cell: (row) => {
      let badgeClass;
      let badgeText;

      if (row.status === "In progress") {
        badgeClass = "badge bg-warning";
        badgeText = row.status;
      } else if (row.status === "Sent") {
        badgeClass = "badge badge-grey";
        badgeText = row.status;
      } else if (row.status === "canceled") {
        badgeClass = "badge bg-danger";
        badgeText = row.status;
      } else {
        badgeClass = "badge bg-success";
        badgeText = row.status;
      }

      return <span className={badgeClass}>{badgeText}</span>;
    },
  },
  {
    name: languageData.body.header.notifications.table.date,
    selector: (row) => row.date,
    sortable: true,
  },
];

const customStyles = {
  table: {
    style: {
      border: "1px solid #dee2e6",
    },
  },
  headRow: {
    style: {
      background: "#edeef1",
      fontWeight: "400",
      textAlign: "center",
      fontSize: "13px",
    },
  },
  cells: {
    style: {
      textAlign: "center",
    },
  },
};

const Notifycontent = ({ data }) => {
  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/general/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <div className="col-xl-12">
      <div className="card custom-card">
        <div className="card-header d-flex align-items-center justify-content-between">
          <div className="card-title">Notifications</div>
          <div className="card-actions">
            <Link to="/profile?tab=consents" className="btn btn-primary">
              {languageData.primary_btn}
            </Link>
          </div>
        </div>

        <div className="card-body">
          <div className="dataTables_wrapper dt-bootstrap5 no-footer">
            <div className="row mb-3" style={{ width: "102%" }}>
              <div className="col-12 d-flex justify-content-end pe-3">
                <label className="d-inline-flex align-items-center">
                  <input
                  name="search"
                    type="search"
                    className="form-control form-control-sm"
                    placeholder="Search..."
                    // value={searchText}
                    // onChange={(e) => setSearchText(e.target.value)}
                  />
                </label>
              </div>
            </div>

            <DataTable
              columns={columns(languageData)}
              data={data}
              customStyles={customStyles}
              pagination
              paginationComponentOptions={{
                rowsPerPageText: "Rows per page",
                rangeSeparatorText: "of",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifycontent;
